type AnalyticsPayload = Record<string, string | number | boolean | null | undefined>;

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

const ANALYTICS_ENDPOINT = import.meta.env.VITE_ANALYTICS_ENDPOINT;

function sendToEndpoint(eventName: string, params: AnalyticsPayload) {
  if (!ANALYTICS_ENDPOINT) return;

  const payload = {
    event: eventName,
    params,
    path: window.location.pathname,
    href: window.location.href,
    timestamp: Date.now(),
  };

  const body = JSON.stringify(payload);
  if (navigator.sendBeacon) {
    const blob = new Blob([body], { type: 'application/json' });
    navigator.sendBeacon(ANALYTICS_ENDPOINT, blob);
    return;
  }

  void fetch(ANALYTICS_ENDPOINT, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body,
    keepalive: true,
  }).catch(() => {
    // Ignore analytics transport errors.
  });
}

function isAdminPath(): boolean {
  try {
    return /^\/admin(\/|$)/.test(window.location.pathname);
  } catch {
    return false;
  }
}

export function trackEvent(eventName: string, params: AnalyticsPayload = {}) {
  try {
    // Exclude internal admin traffic from analytics.
    if (isAdminPath()) return;

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
    }

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: eventName, ...params });
    }

    sendToEndpoint(eventName, params);
  } catch {
    // Keep analytics side-effect free for UX.
  }
}
